import React from 'react';
import icon from '../../../../assets/dbs/db_pubbiz.png';

const PubbizIcon = () => (
    <div>
        <img style = {{height: 25, paddingBottom:5, paddingRight: 5}} src={icon} alt="pubbiz"/>
    </div>
);
export default PubbizIcon;